/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_OriginsInputs */

const en_manage_origins = /** @type {(inputs: Manage_OriginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Origins`)
};

const es_manage_origins = /** @type {(inputs: Manage_OriginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar origenes`)
};

/**
* | output |
* | --- |
* | "Manage Origins" |
*
* @param {Manage_OriginsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_origins = /** @type {((inputs?: Manage_OriginsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_OriginsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_origins(inputs)
	return es_manage_origins(inputs)
});